import Vue from 'vue'

// ============================================================
// 全局窗口尺寸变化事件总线
// 用途：echarts 图表自适应、其他需要监听窗口 resize 的场景
// 用法：
//   import { resizeBus } from '@/plugins/chartResize'
//   created() {
//     this._chartHandler = () => { this.chart && this.chart.resize() }
//     resizeBus.$on('global-resize', this._chartHandler)
//   },
//   beforeDestroy() {
//     resizeBus.$off('global-resize', this._chartHandler)
//   }
// ============================================================
export const resizeBus = new Vue()

let timer = null

/**
 * 在 App.vue created 中调用一次，全局绑定 window resize 广播
 * （防抖 100ms，避免高频触发）
 */
export function initChartResizeListener() {
  if (window.__chartResizeInit) return
  window.__chartResizeInit = true
  window.addEventListener('resize', () => {
    clearTimeout(timer)
    timer = setTimeout(() => {
      resizeBus.$emit('global-resize')
    }, 100)
  })
}

/**
 * 一键绑定 echarts 实例的自适应（创建时绑定，组件销毁自动解绑）
 * @param {object} chart echarts 实例
 * @param {object} vm 当前组件实例（用于自动解绑）
 * @returns {function} handler，可手动解绑用 resizeBus.$off('global-resize', handler)
 */
export function bindChartResize(chart, vm) {
  if (!chart || typeof chart.resize !== 'function') return null
  const handler = () => {
    if (chart && typeof chart.resize === 'function') chart.resize()
  }
  resizeBus.$on('global-resize', handler)
  if (vm && typeof vm.$once === 'function') {
    vm.$once('hook:beforeDestroy', () => {
      resizeBus.$off('global-resize', handler)
    })
  }
  return handler
}
